export default defineNuxtRouteMiddleware(async (to, from) => {
  const { setSearchValue } = useSearchStore()

  const isPreviousRouteGame = from.fullPath.includes('casino/games')
  if (!isPreviousRouteGame) {
    setSearchValue('')
  }
})
